import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';
import { CerberusStatsFields } from '@hcs/types';

import { CerberusStatsListingStatsChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useZipListingStatsTimeSeries } from '../../hooks';
import { getIsRentalListingStatsField } from '../../utils';

interface ZipListingStatsLineChartProps {
  className?: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  zipcode: string;
  cerberusStatsField: CerberusStatsFields;
  theme?: Partial<ChartTimeSeriesLineTheme>;
  propertyType: 'singleFamily' | 'condo';
  setPropertyType?: (propertyType: 'singleFamily' | 'condo') => void;
  showPropertyTypeWarning?: boolean;
}
export const ZipListingStatsChart = ({
  className,
  zipcode,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  cerberusStatsField,
  theme,
  propertyType,
  setPropertyType,
  showPropertyTypeWarning,
}: ZipListingStatsLineChartProps) => {
  const dataHcName = `zipcode-${cerberusStatsField}-chart`;
  const { data, isLoading } = useZipListingStatsTimeSeries({
    fromDate,
    toDate,
    zipcode,
    propertyType,
  });
  const isRentalField = getIsRentalListingStatsField(cerberusStatsField);

  return (
    <CerberusStatsListingStatsChart
      dataHcName={dataHcName}
      className={className}
      cerberusStatsField={cerberusStatsField}
      isRentalField={isRentalField}
      isLoading={isLoading}
      theme={theme}
      // note that zip does not have rental listing data
      data={isRentalField ? null : data}
      propertyType={propertyType}
      setPropertyType={setPropertyType}
      showPropertyTypeWarning={showPropertyTypeWarning}
    />
  );
};
